var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"currency"},[_vm._v("RO")])
}
var staticRenderFns = []

export { render, staticRenderFns }